import script from "./BasicSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicSetting.vue?vue&type=script&setup=true&lang=ts"

import "./BasicSetting.vue?vue&type=style&index=0&id=67fcc6fa&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67fcc6fa"]])

export default __exports__